import { Message, messageBannerFunctions, MessageTypes } from '@nhl/nhl-react-ui/lib/MessageBanner';

import * as accountAPI from 'media-base-ui/utils/accountAPI';

import actionCreators from './actionCreators';
import { emailSubscriptionsOperations } from '../emailSubscriptions';

const changeValue = actionCreators.changeValue;
const hydrateProfile = actionCreators.hydrateProfile;

const submitRegister = (profile, validationCode) => async dispatch => {
    dispatch(actionCreators.requestRegister());

    try {
        await accountAPI.register({
            profile,
            validationCode
        });

        dispatch(actionCreators.registerResponse(true, []));
        messageBannerFunctions.dispatchMessage(new Message('Account created successfully!',
            MessageTypes.SUCCESS));
    } catch (errors) {
        if (!Array.isArray(errors)) {
            submitFailHelper([], dispatch);
            throw errors;
        }

        submitFailHelper(errors, dispatch);
    }
};

const submitSave = profile => async dispatch => {
    dispatch(actionCreators.requestSave());

    try {
        await accountAPI.saveProfile({
            profile,
            validateProfile: true
        });

        if (profile.subscriptionTeams) {
            profile.selectedTeams = profile.subscriptionTeams;
        }

        dispatch(actionCreators.saveResponse(true, []));
        dispatch(actionCreators.hydrateProfile(profile));
        messageBannerFunctions.dispatchMessage(new Message('Profile saved successfully',
            MessageTypes.SUCCESS));
    } catch (errors) {
        if (!Array.isArray(errors)) {
            const body = await errors.response.json();
            if (body.message.indexOf('same email') >= 0) {
                messageBannerFunctions.dispatchMessage(new Message('An account already exists using that email. Please specify a different one.',
                    MessageTypes.ERROR));
            } else {
                throw errors;
            }
            submitFailHelper([], dispatch);
            return;
        }

        submitFailHelper(errors, dispatch);
    }
};

const submitFailHelper = (errors, dispatch) => {
    dispatch(actionCreators.registerResponse(false, errors));
    messageBannerFunctions.dispatchMessage(new Message('There were some problems with the form. See below for more details.',
        MessageTypes.ERROR));
};

const fetchIndustryTypes = isPublic => async dispatch => {
    dispatch(actionCreators.requestIndustryTypes());

    try {
        const data = await accountAPI.fetchIndustryTypes({isPublic});
        dispatch(actionCreators.industryTypesResponse(true, data.data, []));
    } catch (errors) {
        dispatch(actionCreators.industryTypesResponse(false, null, errors));
    }
};

const fetchRequestedAccountInfo = validationCode => async dispatch => {
    dispatch(actionCreators.requestAccountInfo());

    try {
        const data = await accountAPI.fetchRequestedAccountInfo({
            isPublic: true,
            validationCode
        });

        if (data.total > 0) {
            dispatch(actionCreators.accountInfoResponse(true, []));
            dispatch(actionCreators.hydrateProfile(data.data[0]));
        } else {
            dispatch(actionCreators.accountInfoResponse(false, []));
            messageBannerFunctions.dispatchMessage(new Message('We could not verify that you are allowed to create an account. Registration has ' +
                'been disabled. Please follow the link from the email you received to successfully register.',
                MessageTypes.ERROR));
        }
    } catch (errors) {
        dispatch(actionCreators.accountInfoResponse(false, null, errors));
    }
};

const fetchAccountInfo = () => async dispatch => {
    dispatch(actionCreators.requestAccountInfo());

    try {
        const data = await accountAPI.fetchAccountInfo();
        const profile = data.data[0];
        profile.selectedTeams = profile.subscriptionTeams;

        dispatch(actionCreators.accountInfoResponse(true, []));
        dispatch(actionCreators.hydrateProfile(profile));
        dispatch(emailSubscriptionsOperations.hydrateSubscriptions(profile));
    } catch (errors) {
        dispatch(actionCreators.accountInfoResponse(false, null, errors));
    }
};

export default {
    changeValue,
    hydrateProfile,
    submitRegister,
    submitSave,
    fetchIndustryTypes,
    fetchRequestedAccountInfo,
    fetchAccountInfo
};